// Centralized replace statement functions - keeping original functionality intact

export function cleanTextForAnalysis(text: string): string {
  return text
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&#39;/g, "'")
    .replace(/&nbsp;/g, ' ')
    .replace(/[^a-zA-Z0-9\s.,;:!?()\[\]{}"'\n\r-]/g, '')
    .replace(/([a-zA-Z])\s+([a-zA-Z])(?=\s|$|[.,;:!?])/g, '$1$2')
    .replace(/([0-9])\s+([0-9])/g, '$1$2')
    .replace(/([0-9])\s*\.\s+/g, '$1. ')
    .replace(/\(\s+/g, '(')
    .replace(/\s+\)/g, ')')
    .replace(/(\d+)100/g, '$1/100')
    .replace(/(OVERALL COMPLIANCE SCORE: \d+\/100)\s*\n\s*\(Total word count: (\d+ words)\)/g, '$1 ($2)')
    .replace(/\\n/g, '\n')
    .replace(/\s+/g, ' ')
    .replace(/\n\s+/g, '\n')
    .replace(/\s+\n/g, '\n')
    .trim();
}

export function cleanScatteredText(text: string): string {
  return text
    .replace(/([A-Z])\s+([A-Z])\s+([A-Z])\s+([A-Z])/g, '$1$2$3$4')
    .replace(/([A-Z])\s+([A-Z])\s+([A-Z])/g, '$1$2$3')
    .replace(/([A-Z])\s+([A-Z])/g, '$1$2')
    .replace(/([A-Z0-9])\s+([A-Z0-9])\s+([A-Z0-9])\s+([A-Z0-9])/g, '$1$2$3$4')
    .replace(/([A-Z0-9])\s+([A-Z0-9])\s+([A-Z0-9])/g, '$1$2$3')
    .replace(/([A-Z0-9])\s+([A-Z0-9])/g, '$1$2')
    .replace(/([a-z0-9])\s+([a-z0-9])/g, '$1$2')
    .replace(/(\d)\s*\.\s*/g, '$1. ')
    .replace(/(\d)\s*\/\s*(\d)/g, '$1/$2')
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&#39;/g, "'")
    .replace(/&nbsp;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function cleanOcrText(text: string): string {
  return text
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&#39;/g, "'")
    .replace(/&nbsp;/g, ' ')
    .replace(/([a-zA-Z0-9])\s+([a-zA-Z0-9])/g, '$1$2')
    .replace(/([0-9])\s*\.\s*/g, '$1. ')
    .replace(/\s+/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .trim();
}

export function escapeHtmlForDocument(text: string): string {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\n/g, "<br>");
}

export function cleanFormatUtils(str: string): string {
  let cleaned = str;
  
  cleaned = cleaned.replace(/\*\*([^*]+?)\*\*/g, '$1');
  cleaned = cleaned.replace(/__([^_]+?)__/g, '$1');
  cleaned = cleaned.replace(/(?<!\*)\*([^*\n]+?)\*(?!\*)/g, '$1');
  cleaned = cleaned.replace(/(?<!_)_([^_\n]+?)_(?!_)/g, '$1');
  
  cleaned = cleaned.replace(/^\s*#{1,6}\s+/gm, '');

  cleaned = cleaned.replace(/\t+/g, ' ');
  cleaned = cleaned.replace(/ {2,}/g, ' ');
  
  cleaned = cleaned.replace(/([a-z])([A-Z])/g, '$1 $2');
  cleaned = cleaned.replace(/[^a-zA-Z0-9\s.,;:!?()\[\]{}"'\n\r-]/g, '');
  
  cleaned = cleaned.replace(/([a-zA-Z])\s+([a-zA-Z])(?=\s|$|[.,;:!?])/g, '$1$2');
  cleaned = cleaned.replace(/([0-9])\s+([0-9])/g, '$1$2');
  
  cleaned = cleaned.replace(/([0-9])\s*\.\s+/g, '$1. ');

  cleaned = cleaned.replace(/\(\s+/g, '(');
  cleaned = cleaned.replace(/\s+\)/g, ')');
  
  cleaned = cleaned.replace(/&quot;/g, '"');
  cleaned = cleaned.replace(/&amp;/g, '&');
  cleaned = cleaned.replace(/&lt;/g, '<');
  cleaned = cleaned.replace(/&gt;/g, '>');
  cleaned = cleaned.replace(/&#39;/g, "'");
  cleaned = cleaned.replace(/&nbsp;/g, ' ');
  
  cleaned = cleaned.replace(/\\n/g, '\n');
  cleaned = cleaned.replace(/\r\n|\r/g, '\n');
  
  cleaned = cleaned.replace(/(\d+)100/g, '$1/100');
  cleaned = cleaned.replace(/(OVERALL COMPLIANCE SCORE: \d+\/100)\s*\n\s*\(Total word count: (\d+ words)\)/g, '$1 ($2)');
  
  cleaned = cleaned.replace(/\n\s+/g, '\n');
  cleaned = cleaned.replace(/\s+\n/g, '\n');
  cleaned = cleaned.replace(/[^\n]\s{2,}[^\n]/g, match => match.replace(/\s+/g, ' '));
  
  return cleaned.trim();
}

export function cleanPDFText(text: string): string {
  return text
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&#39;/g, "'")
    .replace(/&nbsp;/g, ' ')
    .replace(/[^a-zA-Z0-9\s.,;:!?()\[\]{}"'\n\r-\/]/g, '')
    .replace(/([a-zA-Z])\s+([a-zA-Z])(?=\s|$|[.,;:!?])/g, '$1$2')
    .replace(/([0-9])\s+([0-9])/g, '$1$2')
    .replace(/([0-9])\s*\.\s+/g, '$1. ')
    .replace(/\(\s+/g, '(')
    .replace(/\s+\)/g, ')')
    .replace(/0100/g, '0/100')
    .replace(/(\d+)100/g, '$1/100')
    .replace(/\\n/g, '\n')
    .replace(/\*\*([^*]+?)\*\*/g, '$1')
    .replace(/__([^_]+?)__/g, '$1')
    .replace(/(?<!\*)\*([^*\n]+?)\*(?!\*)/g, '$1')
    .replace(/(?<!_)_([^_\n]+?)_(?!_)/g, '$1')
    .replace(/^\s*#{1,6}\s+/, '')
    .replace(/^\s*[-*•]\s+/, '')
    .replace(/^MISSING REQUIREMENTS/gi, 'Missing Requirements')
    .replace(/^RECOMMENDATIONS/gi, 'Recommendations')
    .replace(/^SATISFIED REQUIREMENTS/gi, 'Satisfied Requirements')
    .replace(/(OVERALL COMPLIANCE SCORE: \d+\/100)\s*\n\s*\(Total word count: \d+ words\)/g, '$1 (Total word count: $2)')
    .replace(/\s+/g, ' ')
    .replace(/\n\s+/g, '\n')
    .replace(/\s+\n/g, '\n')
    .trim();
}

export function cleanMarkdownLine(line: string): string {
  return line
    .replace(/\*\*([^*]+?)\*\*/g, '$1')
    .replace(/__([^_]+?)__/g, '$1')
    .replace(/(?<!\*)\*([^*\n]+?)\*(?!\*)/g, '$1')
    .replace(/(?<!_)_([^_\n]+?)_(?!_)/g, '$1')
    .replace(/^\s*#{1,6}\s+/, '')
    .replace(/^\s*[-*•]\s+/, '');
}